import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

import moment from 'moment';
class FirebaseServiceOne {
  constructor(apiService) {
    this.apiService = apiService;
    this.fb = null;
  }

  async initFirebase() {
    try {
      if (this.fb && this.fb.firebase_.apps.length !== 0) {
        return;
      }
      const config = await this.apiService.get('/api/v1/one/firebase/config/web');
      this.fb = firebase.initializeApp(config);
      const user = this.fb.auth().currentUser;
      if (!user) {
        this.initToken();
      }
    } catch (e) {
      console.log(e, 'Eror in init Firebase');
    }
  }

  async initToken() {
    try {
      const auth = localStorage.getItem('auth');
      if (!auth) {
        return;
      }
      const { email } = JSON.parse(auth);
      const data = await this.apiService.get('/api/v1/auth/firebase');
      this.signIn(data.data.token, email);
    } catch (e) {
      console.log(e, 'e');
    }
  }

  async signIn(token, email) {
    if (!this.fb || this.fb.firebase_.apps.length === 0) {
      await this.initFirebase();
    }
    this.fb
      .auth()
      .signInWithCustomToken(token)
      .then((result) => {
        return result.user.updateEmail(email);
      })
      .catch((error) => {
        console.log(error, 'error');
      });
  }

  async subscribeOnMessage(hash, cb, timeOffset) {
    var now = moment.utc().valueOf() + timeOffset;

    var ref = this.fb.database().ref(`rooms/${hash}`).orderByChild('date').startAt(now);

    const removeFunction = () => {
      ref.off();
    };

    ref.on('child_added', (snapshot) => {
      const data = snapshot.val();
      cb({
        data: {
          ...data,
          key: snapshot.key,
          fileURL: null,
          onLoaded: false,
          date: moment.utc(snapshot.date).format('YYYY-MM-DD HH:mm:ss'),
        },
        removeFunction,
      });
    });
  }

  async uploadFile({ hash, file, ref, message }) {
    const fileName = message.message;

    const storageRef = this.fb.storage().ref(`rooms/${hash}/${fileName}`);

    const uploadTask = storageRef.put(file);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        ref.progress = progress;
      },
      (error) => {
        console.log(error, 'error');
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then(() => {
          ref.isUploading = false;

          const msg = {
            messageType: 'file',
            message: message.message,
            contentType: message.contentType,
            date: moment.utc().valueOf(),
            userId: message.userId,
            userName: message.userName,
          };

          this.postMessage(hash, msg);
        });
      }
    );
  }

  async getAllMessages({ hash, lastKey = '', cb, limit }) {
    var ref = this.fb.database().ref(`rooms/${hash}`).orderByKey().endBefore(lastKey).limitToLast(limit);

    ref.once('value', (snapshot) => {
      const data = snapshot.val();
      cb(data);
    });
  }

  async getFileURL({ hash, fileName }) {
    const storageRef = this.fb.storage().ref(`rooms/${hash}/${fileName}`);

    const url = await storageRef.getDownloadURL();
    return url;
  }

  async postMessage(hash, message) {
    var ref = this.fb.database().ref(`rooms/${hash}`);
    ref.push(message);
  }
}

export default FirebaseServiceOne;
